import classNames from 'classnames'
import React, { ReactNode } from 'react'

type HoverHintProps = {
  children: ReactNode
  hintLabel?: string
  position?: 'top' | 'bottom'
  align?: 'center' | 'left' | 'right'
  ignoreStyle?: boolean
}

const HoverHint = (props: HoverHintProps) => {
  const position = props.position || 'top'
  const stylePosition = position === 'bottom' ? 'top-full' : 'bottom-full'
  const ignoreStyle = props.ignoreStyle ?? false

  const align = props.align ?? 'center'
  const alignClasses =
    align === 'center'
      ? 'left-1/2 -translate-x-1/2'
      : align === 'right'
        ? 'left-0 translate-x-0'
        : 'right-0 translate-x-0'

  return (
    <React.Fragment>
      {!props.hintLabel && props.children}
      {props.hintLabel && <span className="relative inline-flex group">
        <span className={classNames('flex gap-4 ',
          { 'text-blue-400 font-bold cursor-pointer': !ignoreStyle}
        )}>
          {props.children}
        </span>

        <span
          className={classNames(`pointer-events-none absolute z-10 mt-2
                whitespace-nowrap rounded-md bg-gray-900 px-2 py-1 text-xs text-white
                opacity-0 shadow-lg transition-opacity
                group-hover:opacity-100 ${stylePosition} ${alignClasses}
              `)}
        >
          {props.hintLabel}
        </span>
      </span>}
    </React.Fragment>
  )
}

export default HoverHint
